<template>
    <div class="flex flex-col items-center my-6">
        <div class="mx-auto max-w-screen-md px-2 md:px-0 flex flex-col gap-y-2 items-center mb-4">
            
                <img  :src="img" :alt="`Logotip del grup ${grup.nom}`" class="mx-auto max-h-32 aspect-square"/>
            <div class="flex flex-col items-center">
                <h1 class="text-xl font-bold text-center">{{grup.nom}}</h1>
                <a v-if="grup.link?.length" class=" text-red-600 hover:text-red-400 hover:underline inline-flex items-center gap-1"
                            title="Pàgina Web del Grup"
                            :href="grup.link"
                            target="_blank" alt="Pàgina Web de la Colla">
                               <font-awesome-icon :icon="['fas','globe']" class="text-lg"/> {{ grup.link_nom }}
                        </a>
            </div>
            <p>{{grup.descripcio}}</p>
        </div >

            <MosaicRenderer v-for="value in grup.inclou" 
            :key="value" 
            :llista="colles" 
            :escuts="true" 
            :nom_color="false" 
            :icones_estat="false" 
            :tipus="[value]"
            :titol="`Colles ${format(value)} del grup ${grup.nom}` "/>
    </div>
</template>
<script setup>
    import {onMounted, inject,defineProps,computed} from 'vue'
    import Grups from '@/json/grups.json'
    import Relacions from '@/json/relacions.json'

    import MosaicRenderer from '@/components/MosaicRenderer.vue'
    const props = defineProps({
        id:{
            type:String,
            required:true
        }
    })
    const grup=computed(()=>{
        return Grups.find(g=>g.id===props.id)
    })

    const img = computed(()=>{
        return require(`@/assets/grups/${grup.value.id}.svg`)
    })
    const dades = inject('dades')
    const collesGrup=computed(()=>{
        return Relacions.filter(r=>r.grups.includes(props.id)).map(r=>r.id)
        
    })

    const colles = computed (()=>{
        return dades.filter(c=>collesGrup.value.includes(c.id))
    })
    console.log(collesGrup.value)

    onMounted(()=>{
        document.title=`${grup.value.nom} - Mosaic Casteller`

    })
    function format(valor){
        const mapa={convencional:'Convencionals',
        universitaria:'Universitàries',
        internacional:'Internacionals'}
        return mapa[valor]||"Error"
    }
    
    
</script>